<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="抄送标题">
              <a-input placeholder="请输入抄送标题" v-model="queryParam.title"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="流程名称">
              <a-input placeholder="请输入流程名称" v-model="queryParam.flowName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="流程类别">
              <a-select @change="handleQuery" v-model="queryParam.category" placeholder="请选择流程分类" allowClear>
                <a-select-option value="">请选择</a-select-option>
                <a-select-option v-for="category in categorys" :key="category.id" :value="category.id">{{category.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="发起人姓名">
                <a-input placeholder="请输入发起人姓名" v-model="queryParam.initiatorRealname"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="10" :lg="11" :md="12" :sm="24">
              <a-form-item label="创建日期">
                <j-date :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" placeholder="请选择开始时间" class="query-group-cust" v-model="queryParam.createTime_begin"></j-date>
                <span class="query-group-split-cust"></span>
                <j-date :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" placeholder="请选择结束时间" class="query-group-cust" v-model="queryParam.createTime_end"></j-date>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="查看状态">
                  <a-select @change="searchQuery" v-model="queryParam.state" placeholder="请选择查看状态" allowClear>
                    <a-select-option value="已读">已读</a-select-option>
                    <a-select-option value="未读">未读</a-select-option>
                  </a-select>
                </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('流程抄送表')">导出</a-button> -->
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div class="table-fixed">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleFlowRecord(record)">详情</a>

          
        </span>

      </a-table>
    </div>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import { putActions,putAppraisal,getAction } from '@/api/manage'
  import {categoryList} from "@/views/OAoffice/flowable/api/definition";
  import jDate from "@/components/jeecg/JDate";

  export default {
    name: 'FlowCcList',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      jDate
    },
    data () {
      return {
        description: '流程抄送表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'抄送标题',
            align:"center",
            dataIndex: 'title',
            width: 150,
            ellipsis: true,
          },
          {
            title:'流程名称',
            align:"center",
            dataIndex: 'flowName',
            width: 150,
            ellipsis: true,
          },
          {
            title:'流程分类',
            align:"center",
            dataIndex: 'category',
            width: 100,
            ellipsis: true,
          },
          // {
          //   title:'业务主键',
          //   align:"center",
          //   dataIndex: 'businessKey'
          // },
          {
            title:'用户',
            align:"center",
            dataIndex: 'username',
            width: 100,
            ellipsis: true,
          },
          {
            title:'发起人账号',
            align:"center",
            dataIndex: 'initiatorUsername',
            width: 100,
            ellipsis: true,
          },
          {
            title:'发起人姓名',
            align:"center",
            dataIndex: 'initiatorRealname',
            width: 100,
            ellipsis: true,
          },
          {
            title:'创建日期',
            align:"center",
            dataIndex: 'createTime',
            width: 150,
            ellipsis: true,
          },
          {
            title:'查看状态',
            align:"center",
            dataIndex: 'state',
            width: 100,
            ellipsis: true,
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/jeecg-oa/flowable/flowCc/list",
          delete: "/jeecg-oa/flowable/flowCc/delete",
          deleteBatch: "/jeecg-oa/flowable/flowCc/deleteBatch",
          exportXlsUrl: "/jeecg-oa/flowable/flowCc/exportXls",
          importExcelUrl: "jeecg-oa/flowable/flowCc/importExcel",
          updateViewStatus: "/jeecg-oa/flowable/flowCc/updateStateById",
        },
        dictOptions:{},
        superFieldList:[],
        // 查询参数
        queryParams: {
          pageNo: 1,
          pageSize: 10,
          name: null,
          // category: null,
          key: null,
          tenantId: null,
          deployTime: null,
          derivedFrom: null,
          derivedFromRoot: null,
          parentDeploymentId: null,
          engineVersion: null
        },
        categorys:[]
      }
    },
    created() {
    this.getSuperFieldList();
    categoryList({}).then(res => {
      this.categorys = res.result || []
    })
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      /** 流程流转记录 */
      handleFlowRecord(row){
        console.log("handleFlowRecord row=",row);
        getAction(this.url.updateViewStatus, { id: row.id }).then(res => {
          if (res.success) {
            console.log(res);
          }
        })
        this.$router.push({ path: '/OAoffice/flowable/task/record/index',
          query: {
            procInsId: row.instanceId,
            deployId: row.deploymentId,
            taskId: row.taskId,
            businessKey: row.businessKey,
            category: row.category,
            finished: false,
            metaTitle: row.flowName,
            isOaRoute: '/OAoffice/flowable/task/cc/index',
        }})
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'title',text:'抄送标题',dictCode:''})
        fieldList.push({type:'string',value:'flowId',text:'流程ID',dictCode:''})
        fieldList.push({type:'string',value:'flowName',text:'流程名称',dictCode:''})
        fieldList.push({type:'string',value:'category',text:'流程分类',dictCode:''})
        fieldList.push({type:'string',value:'deploymentId',text:'发布ID',dictCode:''})
        fieldList.push({type:'string',value:'instanceId',text:'流程实例ID',dictCode:''})
        fieldList.push({type:'string',value:'taskId',text:'任务ID',dictCode:''})
        fieldList.push({type:'string',value:'businessKey',text:'业务主键',dictCode:''})
        fieldList.push({type:'string',value:'username',text:'用户',dictCode:''})
        fieldList.push({type:'string',value:'initiatorUsername',text:'发起人账号',dictCode:''})
        fieldList.push({type:'string',value:'initiatorRealname',text:'发起人姓名',dictCode:''})
        fieldList.push({type:'datetime',value:'createTime',text:'创建日期'})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>